import { Component, OnInit } from '@angular/core';

import { NonIntegratedAppFacade } from '@app/core/facades/non-integrated-app.facade';
import FilterChange from '@app/shared/filters/filter-change.model';
import { FilterType } from '@app/shared/components/sub-header/filter-type.model';
import FilterComponent from '@app/shared/filters/filter.component';

const SIZE = '198px';

@Component({
  selector: 'app-filter-non-integrated-app',
  templateUrl: '../filter.component.html',
  styleUrls: ['../filter.component.scss'],
})
export default class NonIntegratedAppFilterComponent extends FilterComponent implements OnInit {
  public readonly width = SIZE;
  public readonly label = 'App';

  constructor(private readonly _data: NonIntegratedAppFacade) {
    super();
  }

  public update(value: string, _: boolean): void {
    this._data.updateAppId(value);
    this.valueChange.emit(new FilterChange(FilterType.NonIntegratedApp, value));
  }

  ngOnInit() {
    this.init(this._data.appId$, this._data.allApps$, this._data.allApps$, 'learningAppName');
  }
}
